import React from "react";

const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_c28491e5-5c03-477b-b355-463e5041289c/artifacts/zavnb5tk_LOGO%20LOANJUNCTION.png";

// Loan Junction — real PNG logo. `variant` only affects wordmark color / drop-shadow.
export default function Logo({ size = 40, variant = "dark", withWordmark = false }) {
  const wordmarkColor = variant === "light" ? "#ffffff" : "#06152D";
  const subColor = variant === "light" ? "#EBF2FF" : "#52525B";

  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Loan Junction Finance Services"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain", filter: variant === "light" ? "drop-shadow(0 0 12px rgba(255,255,255,0.25))" : "none" }}
      />
      {withWordmark && (
        <div className="leading-tight">
          <div className="font-display font-extrabold tracking-tight text-[15px]" style={{ color: wordmarkColor }}>LOAN JUNCTION</div>
          <div className="font-display text-[10px] tracking-[0.28em] uppercase" style={{ color: subColor }}>Finance Services</div>
        </div>
      )}
    </div>
  );
}
